import { Injectable } from '@angular/core';
import { TopNavigationModel } from './top-navigation-model';

@Injectable()
export class TopNavigationService {

  async getTopNavigationDetails(hostName: string, applicantId: number, setPolicyStatus: boolean,
    setCertificateStatus: boolean, setPaymentConnectorStatus: boolean, setClaimStatus: boolean,
    setProposalStatus: boolean, setSharedPolicySummaryStatus: boolean): Promise<TopNavigationModel> {
    const url = new URL(`/EzLynxCustomerService/v1/top-navigation/${hostName}`, window.location.origin);
    url.searchParams.set('setPolicyStatus', setPolicyStatus ? 'true' : 'false');
    url.searchParams.set('setCertificateStatus', setCertificateStatus ? 'true' : 'false');
    url.searchParams.set('setPaymentConnectorStatus', setPaymentConnectorStatus ? 'true' : 'false');
    url.searchParams.set('setClaimStatus', setClaimStatus ? 'true' : 'false');
    url.searchParams.set('applicantId', applicantId.toString());
    url.searchParams.set('setProposalStatus', setProposalStatus ? 'true' : 'false');
    url.searchParams.set('setSharedPolicySummaryStatus', setSharedPolicySummaryStatus ? 'true' : 'false');
    const response = await fetch(url);
    return await response.json();
  }

  async canDisplayIntegrations(hostName: string, applicantId: number): Promise<boolean> {
    const response = await fetch(`/EzLynxCustomerService/${hostName}/IntegrationHome/GetProductSetting/${applicantId}`);
    return await response.text() === 'True';
  }
}
